
import axios from "axios";
import moment from 'moment'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      id: null,
      clienteId: null,
      chave : null,
      nvenda : null,
      forma: '1',
      cnpj: null,
      nota1: null,
      nota2: null,
      status: ['1','2','3','4','5','6','7','8','9']
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    ID: state => {
        return state.id
    },
    CLIENTE_ID: state => {
        return state.clienteId
    },
    CHAVE: state => {
        return state.chave
    },
    NVENDA: state => {
        return state.nvenda
    },
    FORMA: state => {
        return state.forma
    },
    CNPJ: state => {
        return state.cnpj
    },
    NOTA1: state => {
        return state.nota1
    },
    NOTA2: state => {
        return state.nota2
    },
    STATUS: state => {
        return state.status
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_ID: (state, payload) => {
          state.id = payload
      },
      SET_CLIENTE_ID: (state, payload) => {
          state.clienteId = payload
      },
      SET_CHAVE: (state, payload) => {
        state.chave = payload
      },
      SET_NVENDA: (state, payload) => {
        state.nvenda = payload
      },
      SET_FORMA: (state, payload) => {
        state.forma = payload
      },
      SET_CNPJ: (state, payload) => {
        state.cnpj = payload
      },
      SET_NOTA1: (state, payload) => {
          state.nota1 = payload
      },
      SET_NOTA2: (state, payload) => {
          state.nota2 = payload
      },
      SET_STATUS: (state, payload) => {
          state.status = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.id = null
        state.clienteId = null
        state.chave = null
        state.nvenda = null
        state.forma = '1'
        state.cnpj = null
        state.nota1 = null
        state.nota2 = null
        state.status = ['1','2','3','4','5','6','7','8','9']
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters}) => {
        return new Promise((resolve, reject) => {
          let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
          let dt2 = (getters.DT2 !== null ? getters.DT2 : '')
          let id = (getters.ID !== null ? getters.ID : '')
          let clienteId = (getters.CLIENTE_ID !== null ? getters.CLIENTE_ID : '')
          let chave = (getters.CHAVE !== null ? getters.CHAVE : '')
          let forma = (getters.FORMA !== null ? getters.FORMA : '')
          let nvenda = (getters.NVENDA !== null ? getters.NVENDA : '')
          let cnpj = (getters.CNPJ !== null ? getters.CNPJ : '')
          let nota1 = (getters.NOTA1 !== null ? getters.NOTA1 : '')
          let nota2 = (getters.NOTA2 !== null ? getters.NOTA2 : '')
          let status  = (getters.STATUS !== null ? getters.STATUS : [])
          
          let uri = `/api/protected/notaFiscal/pesquisar?id=${id}&dt1=${dt1}`+
                    `&dt2=${dt2}`
          if (clienteId) {
            uri += `&clienteId=${clienteId}`
            }
          if (chave) {
            uri += `&chave=${chave}`
           } 
           if (forma) {
            uri += `&forma=${forma}`
           }
           if (nvenda) {
            uri += `&nvenda=${nvenda}`
           }
           if (cnpj) {
            uri += `&cnpj=${cnpj}`
           }
           if (nota1) {
            uri += `&nota1=${nota1}`
           }
           if (nota2) {
            uri += `&nota2=${nota2}`
           }
           if (status.length > 0 ) {
            
            let statusSelecao = ''
            let tem = false
            status.forEach(e => {
              if (tem) {
                statusSelecao += '-' + e
              } else {
                statusSelecao += e
                tem = true
              }
            })
            uri += `&status=${statusSelecao}`
           }

          axios
            .get(uri)
            .then(({ data, status }) => {
              commit("SET_LISTA", data);
              if (status === 200 || status === 201) {
                resolve({ data, status });
              }
            })
            .catch(error => {
              reject(error);
            });
        });
      },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/nota-fiscal.js